export default __webpack_public_path__ + "static/media/International.eb4ce03c.svg";